import { createRouter, createWebHistory } from "vue-router";
import { Auth } from 'aws-amplify';

import HomeView from "../views/HomeView.vue";

import FriendAddView from "../views/FriendAddView.vue";
import FriendListView from "../views/FriendListView.vue";
import FriendEditView from "../views/FriendEditView.vue";
import FriendAssignView from "../views/FriendAssignView.vue";


import GiftAddView from "../views/GiftAddView.vue";
import GiftListView from "../views/GiftListView.vue";
import GiftEditView from "../views/GiftEditView.vue";
import GiftAssignView from "../views/GiftAssignView.vue";

import UpcomingView from "../views/UpcomingView.vue";

import AccountView from "../views/AccountView.vue";

//import SignUpCompleteView from "../views/SignUpCompleteView.vue";

import AuthView from "../views/AuthView.vue";

import Store from '../store';

// Blog Views
import BlogView from "../views/BlogView.vue";
import BlogHolidayGiftGuideView from "../views/BlogHolidayGiftGuideView.vue";
import BlogBirthdayGiftIdeasView from "../views/BlogBirthdayGiftIdeasView.vue";
import BlogBudgetFriendlyGiftsView from "../views/BlogBudgetFriendlyGiftsView.vue";
import BlogPersonalizedGiftsView from "../views/BlogPersonalizedGiftsView.vue";
import BlogLastMinuteGiftsView from "../views/BlogLastMinuteGiftsView.vue";
import BlogWeddingGiftsView from "../views/BlogWeddingGiftsView.vue";
import BlogAnniversaryGiftsView from "../views/BlogAnniversaryGiftsView.vue";
import BlogGiftsForDifficultPeopleView from "../views/BlogGiftsForDifficultPeopleView.vue";
import BlogEcoFriendlyGiftsView from "../views/BlogEcoFriendlyGiftsView.vue";
import BlogPresentPlannerGuideView from "../views/BlogPresentPlannerGuideView.vue";

const routes = [
  // HOME
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      title: ''
    }
  },

  // UPCOMING
  {
    path: "/upcoming",
    name: "Upcoming",
    component: UpcomingView,
    meta: {
      title: 'Upcoming', requiresAuth: true
    }
  },

  // PEOPLE

  {
    path: "/people",
    name: "People",
    component: FriendListView,
    meta: {
      title: 'People', requiresAuth: true
    }
  },
  {
    path: "/friend/add",
    name: "FriendAdd",
    component: FriendAddView,
    meta: {
      title: 'Add someone', requiresAuth: true
    }
  },
  {
    path: "/people/edit/:id",
    name: "PeopleEdit",
    component: FriendEditView,
    meta: {
      title: 'Edit Person', requiresAuth: true
    }
  },
  {
    path: "/people/assign/:id",
    name: "PeopleAssign",
    component: FriendAssignView,
    meta: {
      title: 'Assign Person', requiresAuth: true
    }
  },

  // GIFTS

  {
    path: "/gifts",
    name: "Gifts",
    component: GiftListView,
    meta: {
      title: 'Gifts', requiresAuth: true
    }
  },
  {
    path: "/gift/add",
    name: "GiftAdd",
    component: GiftAddView,
    meta: {
      title: 'Add a gift', requiresAuth: true
    }
  },
  {
    path: "/gift/edit/:id",
    name: "GiftEdit",
    component: GiftEditView,
    meta: {
      title: 'Edit Gift', requiresAuth: true
    }
  },
  {
    path: "/people/assign/:id",
    name: "GiftAssign",
    component: GiftAssignView,
    meta: {
      title: 'Assign Gift', requiresAuth: true
    }
  },
  
  // BLOG

  {
    path: "/blog",
    name: "Blog",
    component: BlogView,
    meta: {
      title: 'Blog'
    }
  },
  {
    path: "/blog/holiday-gift-guide",
    name: "BlogHolidayGiftGuide",
    component: BlogHolidayGiftGuideView,
    meta: {
      title: 'Holiday Gift Guide'
    }
  },
  {
    path: "/blog/birthday-gift-ideas",
    name: "BlogBirthdayGiftIdeas",
    component: BlogBirthdayGiftIdeasView,
    meta: {
      title: 'Birthday Gift Ideas'
    }
  },
  {
    path: "/blog/budget-friendly-gifts",
    name: "BlogBudgetFriendlyGifts",
    component: BlogBudgetFriendlyGiftsView,
    meta: {
      title: 'Budget-Friendly Gift Ideas'
    }
  },
  {
    path: "/blog/personalized-gifts",
    name: "BlogPersonalizedGifts",
    component: BlogPersonalizedGiftsView,
    meta: {
      title: 'Personalized Gift Ideas'
    }
  },
  {
    path: "/blog/last-minute-gifts",
    name: "BlogLastMinuteGifts",
    component: BlogLastMinuteGiftsView,
    meta: {
      title: 'Last-Minute Gift Ideas'
    }
  },
  {
    path: "/blog/wedding-gifts",
    name: "BlogWeddingGifts",
    component: BlogWeddingGiftsView,
    meta: {
      title: 'Wedding Gift Guide'
    }
  },
  {
    path: "/blog/anniversary-gifts",
    name: "BlogAnniversaryGifts",
    component: BlogAnniversaryGiftsView,
    meta: {
      title: 'Anniversary Gift Ideas'
    }
  },
  {
    path: "/blog/gifts-for-difficult-people",
    name: "BlogGiftsForDifficultPeople",
    component: BlogGiftsForDifficultPeopleView,
    meta: {
      title: 'Gifts for Hard-to-Buy-For People'
    }
  },
  {
    path: "/blog/eco-friendly-gifts",
    name: "BlogEcoFriendlyGifts",
    component: BlogEcoFriendlyGiftsView,
    meta: {
      title: 'Sustainable and Eco-Friendly Gift Ideas'
    }
  },
  {
    path: "/blog/present-planner-guide",
    name: "BlogPresentPlannerGuide",
    component: BlogPresentPlannerGuideView,
    meta: {
      title: 'How to Use Present Planner Effectively'
    }
  },

  // ACCOUNT

  {
    path: "/account",
    name: "Account",
    component: AccountView,
    meta: {
      title: 'Account', requiresAuth: true
    }
  },

  // AUTH

  {
    path: "/login",
    name: "Login",
    component: AuthView,
    meta: {
      title: 'Welcome back'
    }
  },
  {
    path: "/register",
    name: "Register",
    component: AuthView,
    meta: {
      title: 'Welcome'
    }
  },
  {
    path: "/register/:email",
    name: "Register2",
    component: AuthView,
    meta: {
      title: 'Welcome'
    }
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = "Present Planner - " + to.meta.title;
  } else {
    document.title = "Present Planner";
  }

  if (to.meta.requiresAuth) {
    try {
      await Auth.currentSession();
      if (!Store.getters.user.loggedIn) {
        const user = await Auth.currentAuthenticatedUser();
        Store.dispatch('fetchUser', user);
      }
      next();
    } catch (e) {
      Store.dispatch('resetState');
      next({ name: 'Login' });
    }
  } else {
    next();
  }
});



export default router;
